import script from "./Roles.vue?vue&type=script&setup=true&lang=js"
export * from "./Roles.vue?vue&type=script&setup=true&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=466fe332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466fe332"]])

export default __exports__